import { createContext, useState, useContext } from 'react'
import { useAuth } from './AuthProvider'
import { useConfig } from './ConfigProvider'
import { GetArchiveInvoiceItems, GetArchiveInvoices, GetUnPaidInvoices } from '../Services/InvoiceService'
import { toast } from 'react-toastify'


export const InvoiceContext = createContext()
export const useInvoices = () => {
    return useContext(InvoiceContext)
}

export const InvoicesProvider = ({ children }) => {
    const { api } = useConfig()
    const { authState, logout } = useAuth()
    const [isLoadingUnPaid, setIsLoadingUnPaid] = useState(false)
    const [isLoadingArchive, setIsLoadingArchive] = useState(false)
    const [unPaidInvoices, setUnPaidInvoices] = useState([])
    const [archiveInvoices, setArchiveInvoices] = useState([])

    const handleGetUnPaid = (dateFrom = '', dateTo = '') => {
        setUnPaidInvoices([])
        setIsLoadingUnPaid(true)
        GetUnPaidInvoices(api, authState.custId, dateFrom, dateTo).then(res => {
            setUnPaidInvoices(res.data)
            setIsLoadingUnPaid(false)
        }).catch(e => {
            console.log(e)
            setIsLoadingUnPaid(false)
            setUnPaidInvoices([])
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
        })
    }

    const handleGetArchive = (dateFrom = '', dateTo = '') => {
        setArchiveInvoices([])
        setIsLoadingArchive(true)
        GetArchiveInvoices(api, authState.custId, dateFrom, dateTo).then(res => {
            setArchiveInvoices(res.data)
            setIsLoadingArchive(false)
        }).catch(e => {
            console.log(e)
            setIsLoadingArchive(false)
            setArchiveInvoices([])
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
        })
    }

    const handleGetArchiveInvoiceItems = async (invoice) => {
        try {
            const result = await GetArchiveInvoiceItems(api, invoice.nrDoc, invoice.date, invoice.oddzial)
            return result.data
        } catch (e) {
            console.log(e)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return []
        }
    }

    const handleGetUnPaidInvoiceItems = async (invoice) => {
        try {
            let yy = invoice.docCreated.slice(2, 4)
            let mm = invoice.docCreated.slice(5, 7)
            let dd = invoice.docCreated.slice(8, 10)

            const result = await GetArchiveInvoiceItems(api, invoice.docNumber, yy + mm + dd, invoice.wh)
            return result.data
        } catch (e) {
            console.log(e)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false)
                }
            }
            return []
        }
    }

    return (
        <InvoiceContext.Provider value={
            {
                unPaidInvoices,
                archiveInvoices,
                isLoadingArchive,
                isLoadingUnPaid,
                handleGetArchive,
                handleGetUnPaid,
                handleGetArchiveInvoiceItems,
                handleGetUnPaidInvoiceItems

            }}>
            {children}
        </InvoiceContext.Provider>
    )
}